import React, {useEffect, useState} from "react"
import {RegionCode} from "@casas-diamante/types"
import {getPropertyViews} from "@/api/ga4"
import {getPathUrl, PropertyScheme} from "@/utils"

interface PropertyViewCountProps {
   region: RegionCode
   type: string
   scheme: PropertyScheme
   slug: string
}

function PropertyViewCount({region, type, scheme, slug}: PropertyViewCountProps) {
   const [views, setViews] = useState<number | null>(null)
   const [loading, setLoading] = useState(true)

   useEffect(() => {
      setLoading(true)
      const path = getPathUrl(region, type, scheme, slug)
      getPropertyViews(path)
         .then((count) => {
            setViews(count)
            setLoading(false)
         })
         .catch(() => {
            setViews(null)
            setLoading(false)
         })
   }, [region, type, scheme, slug])

   if (loading) {
      return <p className="text-sm text-gray-500">Cargando...</p>
   }

   if (!views) return null

   return (
      <p className="text-sm text-gray-500">
         Contador de Visitas: {views.toLocaleString("es-MX")}
      </p>
   )
}

export default PropertyViewCount
